import React, { Component } from 'react'
import { Modal, Button, Row, Col } from 'react-bootstrap'
import {reduxForm, Field} from 'redux-form'
import { required } from '../../util/validationFunctions'
import InputText from '../comun/form/InputText'
import InputCheckBox from '../comun/form/InputCheckBox'
import InputSelect from 'react-select'
import InputNumerical from '../comun/form/InputNumerical'
import InputTextArea from '../comun/form/InputTextArea'
import Dropzone from 'react-dropzone'
import { Unarchive } from '@material-ui/icons'
import './ImportarVerracos.scss'

class ImportarVerracos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      archivos: '',
      archivoCargado: false
    }
  }

  onDrop (archivos) {
    archivos.map((archivo, i) => {
      var reader = new FileReader();
      reader.onloadend = () => {
        archivo.content=reader.result
        this.props.actions.subirArchivosImportarVerracos({name: archivo.name, file: reader.result})
        this.setState({archivos: {name: archivo.name, file: reader.result}})
        this.setState({archivoCargado: true})
      }
      reader.readAsDataURL(archivo)
    })
  }

  submitImportarVerracos () {
    this.props.actions.submitImportarVerracos(this.state.archivos)
    this.setState({archivoCargado: false})
  }

  cerrarModalImportarVerracos () {
    this.props.actions.cerrarModalImportarVerracos()
    this.setState({archivos: ''})
    this.setState({archivoCargado: false})
  }

  descargarPlantillaExcelVerracos () {
    this.props.actions.descargarPlantillaExcelVerracos()
  }

  descargarVerracos () {
    this.props.actions.descargarVerracos()
  }

  render () {
    const {
      t, handleSubmit, showModalImportarVerracos, archivo, listImportarVerracos
      } = this.props

    if(!showModalImportarVerracos) return null
    return (
      <Modal show={showModalImportarVerracos} onHide={() => this.cerrarModalImportarVerracos()} aria-labelledby="contained-modal-title-lg" backdrop="static" className="form-carga-index">
      <form>
        <Modal.Header closeButton>
          <Modal.Title>
          {t('IMPORTAR_VERRACOS.TITLE')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <div className="archivos-carga-index">
              <Dropzone
                accept=".xls"
                onDrop={this.onDrop.bind(this)}
                uploadMultiple={true}
                maxFiles={null}
                // maxSize={200000}
              >
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()}  className="custom-file-label">
                    <input {...getInputProps()} />
                    <label><span className="explorar-input-file">{t('COPIA_SEGURIDAD.SUBIR_ARCHIVO')}</span></label>
                  </div>
                )}
              </Dropzone>
            </div>
            {
              Object.keys(archivo).length > 0 ? (
                <p className="nombre-archivo-subido"><Unarchive />{archivo.name}</p>
              ) : null
            }
            {
              Object.keys(listImportarVerracos).length > 0 ? (
                <div className="resultado-importar-verracos">
                {
                  listImportarVerracos.esValido === 0 ? (
                    <ul>
                      <li>{t('IMPORTAR_DATOS.DOCUMENTO_NO_VALIDO')}</li>
                    </ul>
                  ) : (
                    <ul>                                          
                      <li>{t('IMPORTAR_VERRACOS.DOCUMENTO_SUBIDO')}</li>                      
                    </ul>
                  )
                }
              </div>
              ) : null
            }
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button type="button" onClick={() => this.descargarVerracos()} className="btn btn-primary">{t('IMPORTAR_VERRACOS.DESCARGAR_VERRACOS')}</Button>
          <Button type="button" onClick={() => this.descargarPlantillaExcelVerracos()} className="btn btn-primary">{t('IMPORTAR_VERRACOS.DESCARGAR_EJEMPLO_EXCEL')}</Button>
          {
            Object.keys(listImportarVerracos).length === 0 ? (
              <Button type="button" onClick={() => this.submitImportarVerracos()} className="btn btn-primary">{t('CARGA_INDEX.ACEPTAR')}</Button>
            ) : null
          }
          <Button type="button" className="btn btn-white" onClick={() => this.cerrarModalImportarVerracos()}>{t('CARGA_INDEX.CANCELAR')}</Button>
        </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default (reduxForm({
  form: 'ImportarVerracos',
})(ImportarVerracos))